import React from 'react';
import StaticResourceText from '../Format/static-resource-text';
import configJson from '../../Config.json'

const Footer = (props) => {

  let bottomLeftMenu = props.menu
    .filter(x => x.MenuGroupName === "GOCreative_BottomLeft")
    .map(x => x.MenuList);
  let bottomCenterMenu = props.menu
    .filter(x => x.MenuGroupName === "GOCreative_BottomCenter")
    .map(x => x.MenuList);
  let bottomRightMenu = props.menu
    .filter(x => x.MenuGroupName === "GOCreative_BottomRight")
    .map(x => x.MenuList);
  let bottomMenu = props.menu
    .filter(x => x.MenuGroupName === "GOCreative_Bottom")
    .map(x => x.MenuList);

  return (
    <div className='footer'>
      <footer className="footer__wrapper footer container-mt">
        <section className="container">
          <div className="footer__container">
            <div className="widget" data-grid="gc">
              <div className="widget__inner">
                <h2 className="visually-hidden">RRD GO Creative</h2>
                <img className="footer__logo" src={configJson.S3ImageURL + "/static/SVG/rrd_logo_inverse.svg"} alt="RRD Logo" loading='lazy' />
                <div className='footer content' async><StaticResourceText resources={props.resources} reskey={'FOOTER1-LOGO-DESC'}></StaticResourceText></div>
                <ul className="social">
                <StaticResourceText resources={props.resources} reskey={'FOOTER-ICONS'}></StaticResourceText>
                </ul>
              </div>
            </div>

            <div className="widget" data-grid="solution">
              <h3 className="widget-title" async><StaticResourceText resources={props.resources} reskey={'FOOTER1-SUB-TITLE'}></StaticResourceText></h3>
              <ul className="list-unstyled">
                {bottomLeftMenu && bottomLeftMenu[0] && bottomLeftMenu[0].map((menu, index) => (
                  <li key={menu}>   <a href={menu.PageURL}>{menu.MenuName}</a></li>
                ))}
              </ul>
            </div>

            <div className="widget" data-grid="resource">

              {bottomCenterMenu && bottomCenterMenu[0] && bottomCenterMenu[0].map((menu, index) => (
                <h3 className="widget-title" key={menu}>   <a href={menu.PageURL}  target={menu.MenuName === "Careers" ? "_blank" : "_self"} rel={menu.MenuName === "Careers" ? "noopener noreferrer" : undefined}>{menu.MenuName}</a></h3>
              ))}
            </div>

            <div className="widget" data-grid="main">
              {bottomRightMenu && bottomRightMenu[0] && bottomRightMenu[0].map((menu, index) => (
                <h3 className="widget-title" key={menu}> <a href={menu.PageURL}>{menu.MenuName}</a></h3>
              ))}
            </div>
          </div>
        </section>
        <div className="copyright">
          <div className="container">

            <div className="copyright__links">
              <div className="copyright__logo">
                <a target="_blank" rel="noopener noreferrer" href="https://www.rrd.com/">
                  <img className="disclogo lazyloaded" data-src="/assets/img/rrd-disclaimer-logo.png" alt="RR Donnelley Logo" src="/assets/img/rrd-disclaimer-logo.png" />
                </a>
              </div>

              <div className="copyright__text footer-disclaimer disclaimer">
                <ul className="menu__container">
                  {bottomMenu && bottomMenu[0] && bottomMenu[0].map((menu, index) => (
                    menu.MenuName != "Cookie Settings" ? <li className="menu" key={menu}>   <a href={menu.PageURL}>{menu.MenuName}</a></li> : <li className="menu" key={menu}><a id="ot-sdk-btn" className="ot-sdk-show-settings" data-ignore-geolocation="true">{menu.MenuName}</a></li>
                  ))}
                </ul>
                <StaticResourceText resources={props.resources} reskey={'FOOTER-COPYRIGHT-TEXT'}></StaticResourceText>

              </div>

            </div>
          </div>
        </div>
      </footer>

    </div>
  )
}
export default Footer